<form
  [formGroup]="new_password_form_group"
  class="sp-row__space sp-wrap sp-form__standalone sp-padding__x4">
  <h3 class="sp-color__primary sp-margin__bottom-x2">
    {{ 'AUTH.COMPLETE_PSS_TITLE' | translate }}
  </h3>

  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    [ngClass]="getPssFormFieldErrorClass(false)"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__primary sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    <mat-error *ngIf="hasPssLengthError(false)">
      {{ 'ERROR.PASSWORD_LENGTH' | translate }}
    </mat-error>
    <mat-error *ngIf="hasPssPatternError(false)">
      {{ 'ERROR.PASSWORD_PATTERN' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    [ngClass]="getPssFormFieldErrorClass(true)"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_CONFIRM_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password_confirm"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__primary sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
    <mat-error *ngIf="hasPssLengthError(true)">
      {{ 'ERROR.PASSWORD_LENGTH' | translate }}
    </mat-error>
    <mat-error *ngIf="hasPssPatternError(true)">
      {{ 'ERROR.PASSWORD_PATTERN' | translate }}
    </mat-error>
  </mat-form-field>

  <app-shared-button
    class="sp-width__full sp-margin__top-x2"
    [button_class]="'sp-button__main'"
    [spinner_class]="'sp-spinner__main'"
    [cta]="'AUTH.CREATE_ACCOUNT_CTA'"
    [is_disabled]="!isFormValid() || is_complete_pss_running"
    [is_spinner_visible]="is_complete_pss_running"
    (click)="onCompleteClick()"></app-shared-button>
</form>
